export enum Task {
  Classify,
  Segment,
  Annotate,
}
